/**
 * 引用框架
 */
import Vue from 'vue'

import './axios'
import setting from './setting'

import request from '@/utils/request'

import router from '@/router'

// 第三方组件
import NProgress from 'nprogress'  // 顶部进度条
import 'nprogress/nprogress.css'


NProgress.configure({showSpinner: false});

Vue.prototype.$request = request;

Vue.prototype.$setting = setting;

Vue.prototype.$goToHome = () => {
    
  router.push('/');
}

Vue.prototype.$goToSearch = () => {
    
  router.push('/search');
}

Vue.prototype.$goToProjectDetail = (id) => {
  router.push('/project/detail/'+id);
}

Vue.prototype.$getImageUrl = (src) => {
    let url = ''
    if (src) {
        url = setting.imageUrl + src
    } 
    return url
}

Vue.prototype.$textareaFormatter =(content)=>{
    let str = ''
    if(content){
      str = content.replace(/\n/g, "<br />")
    }
    return str

}




